export default __webpack_public_path__ + "static/media/pillarsofheaven.2e155dbf.jpg";